module.exports = __webpack_public_path__ + "img/27600.d4f67bce.jpg";